import { render } from "./InputTextList.vue?vue&type=template&id=67e8059b&scoped=true"
import script from "./InputTextList.vue?vue&type=script&lang=js"
export * from "./InputTextList.vue?vue&type=script&lang=js"

import "./InputTextList.vue?vue&type=style&index=0&id=67e8059b&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e8059b"]])

export default __exports__